"use client";

import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";
import i18n from "../utils/i18n";

interface TranslationContextType {
  language: string;
  setLanguage: Dispatch<SetStateAction<string>>;
}

export const TranslationContext = createContext<
  TranslationContextType | undefined
>(undefined);

export function TranslationProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    const supportedLanguages = ["en", "zh", "th", "ja"];
    for (const lang of navigator.languages) {
      if (supportedLanguages.some(code => {
        if (lang.startsWith(code)) {
          setLanguage(code);
          return true;
        }
      })) {
        break;
      }
    }
  }, []);

  return (
    <TranslationContext.Provider
      value={{
        language,
        setLanguage,
      }}
    >
      {children}
    </TranslationContext.Provider>
  );
}
